// Local dev
module.exports={
"anypoint" : "http://188.166.168.44:8089",
"domain" : "http://localhost:8081",
"ENDPOINT" :"http://localhost:8081",
"SOCKET":"http://localhost:8083",
"socketUrl":"localhost",
"backendUrl":"http://localhost:8083",
// Keycloak (OIDC) — identity provider for "Sign in with Keycloak".
// realm/clientId match the intelog realm + the public SPA client created in Keycloak.
"keycloak": {
  "url":      "http://localhost:8080",
  "realm":    "intelog",
  "clientId": "intelog-web"
}
}

// QA
// module.exports={
//     "anypoint" : "http://qa.intelog.ai:8089",
//     "domain" : "https://qa.intelog.ai:443/controller",
//     "ENDPOINT" :"https://qa.intelog.ai:443/controller",
//     "SOCKET":"https://qa.intelog.ai:443",
//     "socketUrl":"https://qa.intelog.ai:443/process",
//     "backendUrl":"https://qa.intelog.ai:443/process"
// }

// Docker / Customer deployment — set REACT_APP_* in .env before running docker-compose build
// const API_URL     = process.env.REACT_APP_API_URL     || "http://localhost:8081";
// const SOCKET_URL  = process.env.REACT_APP_SOCKET_URL  || "http://localhost:8083";
// const ANYPOINT_URL = process.env.REACT_APP_ANYPOINT_URL || "http://188.166.168.44:8089";

// module.exports = {
//   anypoint:   ANYPOINT_URL,
//   domain:     API_URL,
//   ENDPOINT:   API_URL,
//   SOCKET:     SOCKET_URL,
//   socketUrl:  SOCKET_URL,
//   backendUrl: SOCKET_URL,
// };
